import './Icon.scss';

import { b2x } from '@b2x/react/src';

export const iconsNames = [
  'accessibility',
  'arrow-down',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'bar',
  'call',
  'check',
  'clock-fill',
  'clock-stroke',
  'closed-circle',
  'closed',
  'diner',
  'filters',
  'geolocator',
  'locator',
  'minus',
  'navigator',
  'parking',
  'pet',
  'plus',
  'search',
  'share',
  'voice-recorder',
  'voice-recorder-def',
  'wifi',
] as const;
export type IconName = (typeof iconsNames)[number];

export type IconSize = 10 | 12 | 14 | 16 | 20 | 24;

export interface IconProps extends b2x.IconProps<IconName, IconSize> {}

export const Icon = (props: IconProps) => <b2x.Icon {...props} />;

export const isIconName = (name?: string): name is IconName => b2x.isIconName(iconsNames, name);
